var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quillEditor"},[_c('div',{staticClass:"quill-editor"},[_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.contents)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }